import { useAppSelector } from 'store/hooks';

export const useTrialModalClosedLocalStorageKeyName = () => {
  const customerId = useAppSelector(state => state.customer.id);

  return `trial_modal_closed_at-${customerId}`;
};
